import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './se-image-cta.css.lit';
import { SlotController } from '../../controllers/slot-controller';
import '../se-container/se-container';

/**
 * The SeImageCta component
 * @element se-image-cta
 * @slot image - image
 * @slot heading - title/se-heading
 * @slot description - paragraph text
 * @slot cta - se-link
 */
@customElement('se-image-cta')
export class SeImageCta extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, true);

  render(): TemplateResult {
    return html`<section class="se-image-cta">
      <se-container>
        <div class="se-image-cta--wrapper">
          <div class="se-image-cta--image">
            <slot name="image"></slot>
          </div>
          <div class="se-image-cta--content">
            <slot name="heading"></slot>
            <slot name="description"></slot>
            <slot name="cta"></slot>
          </div>
        </div>
      </se-container>
    </section> `;
  }
}
